module.exports = {
  API: 'https://www.aistan.com.au/api',
  port: 3000
};



// WEBPACK FOOTER //
// ./src/lib/config/development.js